import React from 'react';

const Waypoint = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="waypoint_icon"
    viewBox="0 0 45 36"
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#67D3DF"
        strokeWidth="1.5"
        d="M44.646 34.77c-2.359-.115-4.16-1.247-5.43-3.427-1.298 2.184-3.088 3.393-5.475 3.393-2.385 0-4.166-1.227-5.447-3.365-2.542 4.534-8.46 4.528-10.972.03-1.302 2.15-3.084 3.343-5.459 3.336-2.383-.008-4.157-1.247-5.447-3.392C5.138 33.55 3.32 34.654 1 34.776"
      />
      <path
        fill="#67D3DF"
        stroke="#FFF"
        strokeWidth="1.2"
        d="M22.543 6.769v.212c-1.532 0-2.786 1.238-2.794 2.76-.004.748.283 1.45.807 1.978.53.533 1.24.827 2 .83.733 0 1.425-.292 1.954-.82a2.73 2.73 0 0 0 .817-1.942c0-1.567-1.22-2.8-2.779-2.806l-.005-.212zm.018 6.203a3.235 3.235 0 0 1-2.306-.955 3.184 3.184 0 0 1-.93-2.278c.01-1.754 1.453-3.182 3.218-3.182h.006c1.796.008 3.202 1.427 3.202 3.23a3.148 3.148 0 0 1-.94 2.24 3.169 3.169 0 0 1-2.25.945zm-.794-11.549l-.025.008a.839.839 0 0 1-.195.042 12.051 12.051 0 0 0-3.2.69c-2.495.887-3.722 2.63-4.312 3.934-.843 1.864-.924 4.028-.217 5.788.903 2.256 2.026 4.556 3.532 7.236 1.067 1.903 2.182 3.823 3.26 5.68.454.782.909 1.565 1.361 2.35l.57.983 1.224-2.11c1.157-1.992 2.354-4.05 3.51-6.087 1.223-2.152 2.626-4.724 3.761-7.485.653-1.599.844-2.895.618-4.203-.257-1.48-.707-2.605-1.416-3.538-1.215-1.597-2.984-2.6-5.407-3.069-.325-.063-.663-.107-.99-.15a31.727 31.727 0 0 1-.528-.07l-1.546.001zm.753 27.522l-.916-1.583-1.361-2.35c-1.079-1.857-2.194-3.779-3.263-5.684-1.516-2.697-2.645-5.013-3.556-7.286-.749-1.864-.665-4.152.224-6.119.624-1.38 1.921-3.22 4.557-4.159a12.474 12.474 0 0 1 3.312-.714c.026-.001.063-.012.1-.024l.12-.026h1.607c.204.028.378.05.552.073.334.043.678.088 1.015.153 2.531.49 4.384 1.546 5.665 3.229.752.989 1.227 2.171 1.496 3.722.237 1.372.032 2.781-.643 4.435-1.144 2.784-2.556 5.37-3.786 7.534-1.157 2.037-2.353 4.098-3.51 6.09l-1.313 2.261a1.085 1.085 0 0 1-.068.106l-.232.342z"
      />
    </g>
  </svg>
);

export default Waypoint;
